/* eslint-disable react/prop-types */
import React from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

export const SelectField = (props) => {
	const { options, field, form, defaultValue, error } = props;
	return (
		<div className={`input-block${error ? " input-error" : ""}`}>
			<Select
				defaultValue={defaultValue}
				name={field.name}
				isMulti={props.isMulti}
				value={options ? options.find((option) => option.value === field.value) : null}
				onChange={(option) => {
					form.setFieldValue(field.name, option.value);
					if (typeof props.handleSelectChange === "function") {
						props.handleSelectChange(option.value);
					}
				}}
				onBlur={field.onBlur}
				isSearchable={false}
				options={options}
				className={props.className}
				classNamePrefix={props.className}
				placeholder={props.placeholder}
			/>
			{error && <p className="error-text">{form.errors[field.name]}</p>}
		</div>
	);
};

export const SelectPlain = (props) => {
	const { options, name, error, defaultValue } = props;

	return (
		<div className={`input-block${error ? " input-error" : ""}`}>
			<Select
				defaultValue={defaultValue}
				name={name}
				onChange={(option) => {
					props.handleSelectChange(option);
				}}
				isSearchable={props.isSearchable}
				options={options}
				isMulti={props.isMulti}
				isClearable={props.isClearable}
				className={props.className}
			/>
			{error && <p className="error-text">{error}</p>}
		</div>
	);
};

export const SelectCreatable = (props) => {
	const { options, name, error, defaultValue } = props;

	return (
		<div className={`input-block${error ? " input-error" : ""}`}>
			<CreatableSelect
				defaultValue={defaultValue}
				name={name}
				onChange={(option) => {
					props.handleSelectChange(option);
				}}
				isSearchable={props.isSearchable}
				options={options}
				isMulti={props.isMulti}
				isClearable={props.isClearable}
				isLoading={props.isLoading}
				value={props.selectedOptions}
				className={props.className}
				classNamePrefix={props.className}
			/>
			{error && <p className="error-text">{error}</p>}
		</div>
	);
};
